module.exports = __webpack_public_path__ + "img/ic_arrow.109a1c3c.svg";